export const WORLD_CUP_MODE = false;
